import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=a8e571f8&"
import script from "./ImageElement.vue?vue&type=script&lang=ts&"
export * from "./ImageElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports